var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2308 6.89171L7.28277 12.8398L6.33691 11.8939L13.2308 5L20.1261 11.8939L19.1802 12.8398L13.2308 6.89171ZM12.7586 19.2614L13.7044 18.3156L20.1261 24.7372L19.1802 25.6844L12.7586 19.2614ZM25.6019 19.2614L26.5477 18.3156L32.9694 24.7372L32.0235 25.6844L25.6019 19.2614ZM38.4452 31.1602L39.3911 32.1061L32.4971 39L25.6019 32.1061L26.5477 31.1602L32.4971 37.1083L38.4452 31.1602Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2108 6.89171L5.94586 26.1567L5 25.2108L25.2108 5L32.5783 12.3675L31.6325 13.3134L25.2108 6.89171ZM37.2514 18.646L38.1986 19.5919L18.7892 39L11.4217 31.6325L12.3675 30.6866L18.7892 37.1083L37.2514 18.646Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcon03);
export default __webpack_public_path__ + "static/media/pricing-icon-03.50a4fe9bdfdbefb9bec31eb3d80eedb3.svg";
export { ForwardRef as ReactComponent };